<template>
  <div class="">

    <div class="d-flex gap-10 h-35">

      <router-link
          v-slot="{ href, route, navigate, isActive, isExactActive }"
          :to="{ name: 'Welcome', params: { uuid: id } }"
          :class="'flex-grow-1'"
      >
        <div @click="navigate" class="download-btn px-3 h-35">
          <i class="fa lh-inherit fa-arrow-left"></i> {{ 'Back' | trans }}
        </div>
      </router-link>

      <div class="download-btn h-100 gap-10px h-35 px-3"
           v-bind:title="'Download'| trans"
           @click.stop="download()"
      ><i class="far fa-download lh-inherit"></i> Download
      </div>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import DownloadSelectedBtn from "../Elements/DownloadSelectedBtn.vue";
import PreviewManager from "../../manager/PreviewManager";
import OutputSelectionManager from "../../manager/OutputSelectionManager";
import DownloadManager from "../../manager/DownloadManager";

export default {
  name: "FileNav",
  props: {},
  components: {DownloadSelectedBtn},
  mixins: [
    currentJob,
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    download() {
      DownloadManager.downloadOutput(this.currentOutput);
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.download-btn-main {
  padding: 0 20px;
}

.h-35 {
  height: 35px;
}

.download-btn-dropdown {
  border-left: 2px solid #1158cd;
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
}

.download-btn {
  padding: 0;
  background: #1266F1;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;
  height: 35px;

  &:hover {
    background: #1161e5;
  }
}

.file-action-btn {
  cursor: pointer;
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;

  .dark-mode & {
    background: #383838;;
    border: 1px solid #595959;
    color: white;

    &:hover {
      background: #323232;
    }
  }
}
</style>
